<div class="layout">
    <div class="row col-12 divisor"></div>
    <img class="welcome-text" src="assets/welcome/bienvenido_summer.png"/>
    <div class="ancla-body font-regular">
    </div>
</div>